<template>
  <div>
    <div class="back d-flex flex-row align-center pt-2 ml-4 ml-md-0 mt-12" @click="$router.push({name: 'resultsView'})">
      <img :src="chevronLeft" class="icon mr-4"/><span class="label">{{ $t('page.go_back_to_search') }}</span>
    </div>
    <v-main class="details-view d-flex pa-0 pa-md-6 flex-md-row flex-column my-0 mb-md-16 mt-8">
      <donor-details-component
        :donorDetails="donorDetails"
        :materialType="materialType"
        :publicDonorId="publicDonorId"
        :age="age"
        ref="donorDetails"
        @downloading="setDownloading"
        v-if="!loading"
      />
      <div class="details_loader_wrapper" v-else>
        <v-progress-circular
          indeterminate
          color="primary"
          :size="50"
          :width="5"
          class="details_loader">
        </v-progress-circular>
      </div>
      <v-card 
        v-if="donorDetails && !loading"
        :color="$vuetify.display.mobile ? 'secondarybg' : 'white'"
        rounded="0"
        class="right d-flex flex-column">
        <div
          v-if="!$vuetify.display.mobile"
          class="menu-desktop">
          <div class="menu-item px-3" @click="copyLink">
            <v-icon class="icon">mdi-share-variant-outline</v-icon><div>{{ $t('donor.details.share_btn') }}</div>
          </div>
          <div class="menu-item px-3" @click="$refs.donorDetails.downloadDonorFile">
            <v-icon class="icon">{{downloading ? 'mdi-loading mdi-spin' : 'mdi-tray-arrow-down'}}</v-icon><div>{{ $t('donor.details.download_btn') }}</div>
          </div>
        </div>
        <div>
          <add-to-cart-component 
            :donor-details="donorDetails"
            :maxTrueReservationCount="maxTrueReservationCount"
            :age="this.age"
            @confirmed="showDialog"
            @set-selected-quantity="(q) => selectedQuantity = q"
            @set-mz-grant-used="(u) => mzGrantUsed = u"
            >    
          </add-to-cart-component>
        </div>
        <v-dialog
          v-model="dialogVisible"
          :fullscreen="$vuetify.display.mobile"
          class="d-flex"
          >
          <template>
          </template>
          <div class="close" :class="{'mobile': $vuetify.display.mobile}" @click="dialogVisible = false">
              <v-icon color="primary">mdi-close</v-icon>
          </div>
          <add-to-cart-component 
            :donor-details="donorDetails"
            :maxTrueReservationCount="maxTrueReservationCount"
            :selected-quantity="selectedQuantity"
            :is-material-added="true"
            :is-mz-grant-used="mzGrantUsed"
            :dialog="true"
            :age="this.age"
            @close="hideDialog"
            >    
          </add-to-cart-component>
        </v-dialog>
      </v-card>
      <div class="summary_loader_wrapper" v-else>
        <v-progress-circular
          indeterminate
          color="primary"
          :size="50"
          :width="5"
          class="summary_loader">
        </v-progress-circular>
      </div>
    </v-main>
  </div>
</template>

<script>
import DonorDetailsComponent from '../components/DonorDetailsComponent.vue'
import AddToCartComponent from '../components/AddToCartComponent.vue'
import axios from 'axios';

export default {
  components: {
    DonorDetailsComponent,
    AddToCartComponent
  },
  data() {
    return {
      donorDetails: null,
      age: null,
      maxTrueReservationCount: 0,
      publicDonorId: null,
      dialogVisible: false,
      selectedQuantity: 1,
      mzGrantUsed: false,
      downloading: false,
      loading: false
    }
  },
  computed: {
    materialType() {
      return this.$route.params.materialType == "sperm" ? 'mtSemen' : 'mtCell'
    },
    chevronLeft() {
      return require('../assets/icons/chevron-left.svg');
    }
  },
  watch: {
    '$route.params.id': {
      handler(id) {
        if (id) {
          this.getDonorDetails().then(() => {
            this.$store.dispatch('breadcrumbModule/setRoute', [{
              name: 'breadcrumb.want_to_be_a_parent',
              url: `https://bank.invicta.pl${ this.$t('bank_invicta_path.planning_parenthood') }`,
              absolute: true
            },{
              name: 'breadcrumb.search',
              url: '/'
            },
            {
              name: 'breadcrumb.results',
              url: '/results'
            },
            {
              name: 'breadcrumb.details',
              url: ''
            },
            {
              name: this.donorDetails.donor_process.donor_nickname,
              url: ''
            }
          ])
        })
          
        }
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {
    
  },
  methods: {
    getDonorDetails() {
      this.loading = true;
      return new Promise((resolve, reject) => {
        axios.get(`/api/donor/${this.$route.params.id}/${this.materialType}/data`)
          .then((response) => {
            this.donorDetails = response.data._source
            this.age = response.data.fields.age[0]
            this.maxTrueReservationCount = response.data.fields.max_true_reservation_count[0]
            this.publicDonorId = response.data.fields.public_donor_id[0]
            resolve();
          })
          .catch(err => {
            console.error(err);
            reject();
          })
          .finally(() => {
            this.loading = false;
          });
        })
    },
    copyLink() {
      const absoluteURL = new URL(this.$route.href, window.location.origin).href;
      navigator.clipboard.writeText(absoluteURL);
      this.$refs.donorDetails.alertOpen = true;
    },
    showDialog() {
      this.dialogVisible = true;
    },
    hideDialog() {
      this.dialogVisible = false;
    },
    setDownloading(value) {
      this.downloading = value;
    }
  }
}
</script>


<style lang="scss" scoped>
  .summary_loader_wrapper {
    position: relative;
    width: 100%;
    height: 200px;
    .summary_loader {
      position: absolute;
      top: 20%;
      transform: translate(-50%,-50%);
    }
  }
  .details_loader_wrapper {
    position: relative;
    width: 100%;
    height: 400px;
    .details_loader {
      position: absolute;
      top: 50%;
      transform: translate(-50%,-50%);
    }
  }
  .details-view {
      min-height: 600px;
  }
  @media (min-width: 960px) {
    .summary_loader_wrapper {
      position: relative;
      width: 50%;
      height: unset;
      .summary_loader {
        position: absolute;
        top: 20%;
        transform: translateY(-50%);
      }
    }
    .details_loader_wrapper {
      position: relative;
      width: 50%;
      height: unset;
      .details_loader {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
      }
    }
    .details-view {
      max-width: 996px;
      margin: 0 auto;
      background: white;
    }
    :deep(.v-main__wrap) {
      // background-color: white !important;
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      align-items: flex-start;
      padding: 24px;
      background: white;
    }
    .right {
      height: 100%;
      box-shadow: none;
      width: 500px;
      .menu-desktop {
        @include nsb-font-input;
        font-size: 12px !important;
        line-height: 15px !important;
        box-sizing: border-box;
        background: white;
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        cursor: pointer;
        .menu-item {
          display: flex;
          flex-direction: row;
          align-items: center;
          height: 32px !important;
          border-bottom: 2px solid transparent;
          &:hover {
            border-bottom: 2px solid $nsb-yellow;
          }
          .icon {
            margin-right: 8px;
            font-size: 14px;
          }
        }
      }
    }
  }
  .back {
      @include nsb-back-link;
      font-size: 12px;
      line-height: 18px;
      cursor: pointer;
      position: relative;
    }
  .close{
    position: fixed;
    top: 22px;
    right: 30px;
    z-index: 10;
    &.mobile {
        right: 30px;
    }
  }
</style>